import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-2 rounded-lg font-bold leading-none transition-colors',
  {
    variants: {
      tone: {
        accent: 'border-[0.5px] border-accent-500/50 bg-accent-500/10 text-accent-600',
        brand: 'border-[0.5px] border-brand-600/30 bg-brand-50 text-brand-600',
        neutral: 'border-[0.5px] border-border-subtle bg-surface-muted text-content-muted',
        success: 'border-[0.5px] border-success/30 bg-success-soft text-success',
        danger: 'border-[0.5px] border-danger/30 bg-danger-soft text-danger',
        /** Formule Gold uniquement : distincte de `accent`, réservée à ce seul usage. */
        gold: 'border-[0.5px] border-gold-500/40 bg-gold-500/10 text-gold-700',
      },
      size: {
        sm: 'px-2 py-1 text-[0.6875rem]',
        md: 'py-1 pl-2 pr-3 text-xs',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants> & {
    /** Icône rendue avant le libellé. */
    icon?: ReactNode;
  };

/** Pastille d'état ou d'accès (abonnement, statut d'un envoi…). */
export function Badge({ className, tone, size, icon, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone, size }), className)} {...props}>
      {icon}
      {children}
    </span>
  );
}

export { badgeVariants };
